import React from 'react';
import { text } from '../../../utils/text';
import { Text, Title } from '@gjensidige/core-typography';
import styles from './profil-info-modal.module.less';
import { Modal } from '@gjensidige/core-modal';
import { getProfilEnumName, getProfilInfo, getProfilPillText } from '../../../utils/utils';
import { Pill } from '@gjensidige/core-pill';
import { Spacer } from '../Spacer/Spacer';
import { SecondaryButton } from '@gjensidige/core-buttons';
import { percent } from '@gjensidige/gpf-js-utils/es6/text/formatting';
import { Table } from '@gjensidige/core-table';
export const ProfilInfoModal = ({ visible, onClose, profil, portefølje }) => {
    return (React.createElement(Modal, { closable: true, visible: visible, onClick: onClose, ariaLabel: text.PROFIL_INFO_MODAL.ARIA_LABEL.no, ariaLabelCloseButton: text.PROFIL_INFO_MODAL.ARIA_LABEL_CLOSE.no, className: styles.profilinfoModal, contentClassName: styles.content, strict: false },
        React.createElement(Spacer, null,
            React.createElement("div", null,
                React.createElement(Title, { tag: "h3", size: "h4" }, text.PROFIL_INFO_MODAL.TITLE(getProfilEnumName(profil)).no),
                React.createElement(ProfilInfoPill, { profil: profil }),
                React.createElement(React.Fragment, null, getProfilInfo(profil))),
            React.createElement(Table, { data: getTableData(portefølje.fond), columns: fundTableColumns, withPagination: false }))));
};
const getTableData = (fondliste) => {
    return fondliste.map((fond) => (Object.assign({ navn: fond.navn }, fond.fondsdetaljer)));
};
const fundTableColumns = [
    {
        width: 200,
        accessor: 'navn',
        className: styles.tableHeader,
        Header: text.PROFIL_INFO_MODAL.FOND_TABLE.FONDSNAVN.no,
        Cell: ({ row: { original: data } }) => {
            return (React.createElement(SecondaryButton, { size: 'sm', className: styles.fondButton, href: data.infoUrl, target: "_blank", rel: "noopener noreferrer" }, data.navn));
        },
    },
    {
        accessor: 'avkastningSisteAar',
        className: styles.tableHeader,
        Header: text.PROFIL_INFO_MODAL.FOND_TABLE.AVKASTNING_HITTIL_I_ÅR.no,
        Cell: ({ row: { original: data } }) => {
            return (React.createElement(Text, { size: 'small', className: styles.textCenterDesktop }, percent(data.avkastningSisteAar)));
        },
    },
    {
        accessor: 'avkastningSisteTreAar',
        className: styles.tableHeader,
        Header: text.PROFIL_INFO_MODAL.FOND_TABLE.AVKASTNING_3_ÅR.no,
        Cell: ({ row: { original: data } }) => {
            return (React.createElement(Text, { size: 'small', className: styles.textCenterDesktop }, percent(data.avkastningSisteTreAar)));
        },
    },
    {
        accessor: 'avkastningSisteFemAar',
        className: styles.tableHeader,
        Header: text.PROFIL_INFO_MODAL.FOND_TABLE.AVKASTNING_5_ÅR.no,
        Cell: ({ row: { original: data } }) => {
            return (React.createElement(Text, { size: 'small', className: styles.textCenterDesktop }, percent(data.avkastningSisteFemAar)));
        },
    },
];
export const ProfilInfoPill = ({ profil }) => {
    const text = getProfilPillText(profil);
    if (!text) {
        return null;
    }
    return (React.createElement(Pill, { className: styles.pill, color: "yellow" },
        React.createElement(Text, { size: 'small', className: styles.pillText }, text)));
};
